import { useState } from 'react'
import DestMasterList from './DestMasterList'
import SubDestMasterList from './SubDestMasterList'
import MagoMasterList from './MagoMasterList'

export default function MasterDataTabs() {
  const [activeTab, setActiveTab] = useState<'destinations' | 'sub-destinations' | 'devices'>('destinations')

  return (
    <div className="card">
      <div className="card-header">
        <ul className="nav nav-tabs card-header-tabs">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'destinations' ? 'active' : ''}`}
              onClick={() => setActiveTab('destinations')}
              type="button"
              role="tab"
            >
              <i className="fas fa-map-marker-alt me-2" />
              運用先
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'sub-destinations' ? 'active' : ''}`}
              onClick={() => setActiveTab('sub-destinations')}
              type="button"
              role="tab"
            >
              <i className="fas fa-map-pin me-2" />
              利用先
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'devices' ? 'active' : ''}`}
              onClick={() => setActiveTab('devices')}
              type="button"
              role="tab"
            >
              <i className="fas fa-microchip me-2" />
              端末
            </button>
          </li>
        </ul>
      </div>

      <div className="card-body">
        <div className="tab-content">
          {activeTab === 'destinations' && (
            <div className="tab-pane fade show active">
              <DestMasterList />
            </div>
          )}

          {activeTab === 'sub-destinations' && (
            <div className="tab-pane fade show active">
              <SubDestMasterList />
            </div>
          )}

          {activeTab === 'devices' && (
            <div className="tab-pane fade show active">
              <MagoMasterList />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
